import classes from './index.module.scss';
import Image from '/components/CustomImage';
import styles from '/components/Home/Home.module.css';
import MainCarousel from "/components/MainCarousel";
import { responsiveCharacteristicsProducts } from '/lib/services/helpers/responsive';

const Characteristics = ({
    characteristicsDesktopImage,
    characteristicsMobileImage,
    baseMediaUrl,
    isMobileType
}) => {

    let mobileImages;
    try {
        mobileImages = characteristicsMobileImage && characteristicsMobileImage !== '' 
            ? JSON.parse(characteristicsMobileImage) 
            : [];
        
        if (!Array.isArray(mobileImages) || mobileImages.length === 0) {
            mobileImages = [];
        }
    } catch (error) {
        mobileImages = [];
    }

    return (
        !isMobileType ? (
            <div className={classes.characteristics_section}>
                <Image src={`${baseMediaUrl}characterstic/image/${characteristicsDesktopImage}`} alt="Characteristics" width={1728} height={124} />
            </div>
        ) : (
            <div className={`${styles.sliderContainer} row ${classes.characteristics_section}`}>
                <MainCarousel
                    swipeable
                    draggable={false}
                    showDots={true}
                    responsive={responsiveCharacteristicsProducts}
                    ssr // means to render carousel on server-side.
                    infinite
                    autoPlaySpeed={3000}
                    keyBoardControl
                    partialVisible
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    additionalTransfrom={-10}
                    itemClass={styles.carousel_item_padding}
                    minimumTouchDrag={50}
                >
                    {mobileImages?.sort((a, b) => a.position - b.position)?.map((item) => (
                        <img src={item?.url} alt="Characteristics" className={classes.characteristics_mobile_image} />
                    ))}
                </MainCarousel>
            </div>
        )
    )
};

export default Characteristics;